var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message.show),expression:"message.show"}],staticClass:"c-message",class:_vm.message.status},[_c('div',{staticClass:"c-message--main"},[_c('i',{staticClass:"c-message--icon",class:_vm.message.type}),_c('div',{staticClass:"c-message--tip"},[_vm._v(_vm._s(_vm.message.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }